export const OVERRIDE_KEY = 'pro_override_redirect';

function isTruthyOverride(value?: string | boolean | null): boolean {
  return value === true || value === 'true' || value === '1' || value === '';
}

export function persistOverrideRedirectIfPresent(value?: string | boolean | null) {
  if (typeof window !== 'undefined' && isTruthyOverride(value)) {
    sessionStorage.setItem(OVERRIDE_KEY, '1');
  }
}

export function consumeOverrideRedirect(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const stored = sessionStorage.getItem(OVERRIDE_KEY);
  if (stored) {
    sessionStorage.removeItem(OVERRIDE_KEY);
    return true;
  }
  return false;
}
